import { useCallback } from 'react';
import { useToast } from 'hooks/useToast';
import NotificationsAPI from 'services/API/NotificationsAPI';

type FeedbackPayload = {
  feedback: string;
  project_id?: number;
  company_id?: string;
  page_url: string;
  user_email: string;
};

export const useSendFeedback = () => {
  const { renderCustomToast: toast } = useToast();

  const sendFeedback = useCallback(
    async (payload: FeedbackPayload) => {
      try {
        await NotificationsAPI.postProductFeedback(payload);
        toast({
          title: 'Thank you for your feedback!',
          description: 'The development team will consider it for future improvements.',
          status: 'success',
        });

        return true;
      } catch (_) {
        toast({
          title: 'Error',
          description: 'Something went wrong. Please try again in a couple of minutes.',
          status: 'error',
        });

        return false;
      }
    },
    [toast],
  );

  return { sendFeedback };
};
